var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"loading-animation"}},[(!_vm.state)?_c('div',{staticClass:"loading-animation"},[_c('div',{staticClass:"loading-animation__logo"},[_c('Logo')],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }